/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthorizationLeadWaitlistStatusSetByUser } from './PalAuthorizationLeadWaitlistStatusSetByUser';
import {
    PalAuthorizationLeadWaitlistStatusSetByUserFromJSON,
    PalAuthorizationLeadWaitlistStatusSetByUserFromJSONTyped,
    PalAuthorizationLeadWaitlistStatusSetByUserToJSON,
} from './PalAuthorizationLeadWaitlistStatusSetByUser';

/**
 * 
 * @export
 * @interface PalAuthorizationLeadWaitlistUpdatesInner
 */
export interface PalAuthorizationLeadWaitlistUpdatesInner {
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadWaitlistUpdatesInner
     */
    waitlist_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadWaitlistUpdatesInner
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadWaitlistUpdatesInner
     */
    created_by_user_id?: string;
    /**
     * 
     * @type {PalAuthorizationLeadWaitlistStatusSetByUser}
     * @memberof PalAuthorizationLeadWaitlistUpdatesInner
     */
    created_by_user?: PalAuthorizationLeadWaitlistStatusSetByUser;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadWaitlistUpdatesInner
     */
    created_at?: string;
}

/**
 * Check if a given object implements the PalAuthorizationLeadWaitlistUpdatesInner interface.
 */
export function instanceOfPalAuthorizationLeadWaitlistUpdatesInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalAuthorizationLeadWaitlistUpdatesInnerFromJSON(json: any): PalAuthorizationLeadWaitlistUpdatesInner {
    return PalAuthorizationLeadWaitlistUpdatesInnerFromJSONTyped(json, false);
}

export function PalAuthorizationLeadWaitlistUpdatesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthorizationLeadWaitlistUpdatesInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'waitlist_id': !exists(json, 'waitlist_id') ? undefined : json['waitlist_id'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'created_by_user_id': !exists(json, 'created_by_user_id') ? undefined : json['created_by_user_id'],
        'created_by_user': !exists(json, 'created_by_user') ? undefined : PalAuthorizationLeadWaitlistStatusSetByUserFromJSON(json['created_by_user']),
        'created_at': !exists(json, 'created_at') ? undefined : json['created_at'],
    };
}

export function PalAuthorizationLeadWaitlistUpdatesInnerToJSON(value?: PalAuthorizationLeadWaitlistUpdatesInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'waitlist_id': value.waitlist_id,
        'comment': value.comment,
        'created_by_user_id': value.created_by_user_id,
        'created_by_user': PalAuthorizationLeadWaitlistStatusSetByUserToJSON(value.created_by_user),
        'created_at': value.created_at,
    };
}

